/**
 * Card con borde sutil + header opcional.
 *
 * Sprint 11 v2 S11-V2-02. Replica `.cb-card` + `.cb-card__header` +
 * `.cb-card__title` del handoff (`docs/COMPONENTES.md § Card`).
 */
import type { ReactNode } from 'react';

interface CardProps {
  /** Título de la card. Si se omite, no se renderiza el header. */
  title?: ReactNode;
  /** Acción a la derecha del título (link "Ver todos", botón, badge). */
  actionRight?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, actionRight, children, className = '' }: CardProps) {
  return (
    <div
      className={`bg-bg-card border-[0.5px] border-white/[0.08] rounded-md p-5 ${className}`.trim()}
    >
      {(title || actionRight) && (
        <div className="flex justify-between items-center mb-3">
          {title && (
            <div className="text-md font-medium text-text-primary">{title}</div>
          )}
          {actionRight && <div>{actionRight}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
